import QuoteBuilderLayout from './QuoteBuilderLayout';
import SelectUnit from './SelectUnit';
import SelectQuantity from './SelectQuantity';
import OptionLengthWithUnit from './OptionLengthWithUnit';
import OptionBoolean from './OptionBoolean';
import OptionIntegerWithRange from './OptionIntegerWithRange';
import OptionSelect from './OptionSelect';
import DrawingMaterialChooser from './DrawingMaterialChooser';
import PrintingColorChooser from './PrintingColorChooser';
import HotStampingChooser from './HotStampingChooser';
import SubmitButton from './SubmitButton';

export default {
  maxWidth: 320,
  defaultHighlightColor: '#4285f4',
  QuoteBuilderLayout,
  SelectUnit,
  SelectQuantity,
  OptionLengthWithUnit,
  OptionBoolean,
  OptionIntegerWithRange,
  OptionSelect,
  DrawingMaterialChooser,
  PrintingColorChooser,
  HotStampingChooser,
  SubmitButton,
};
